import { ConfigFacadeService } from '@core/services/config/config-facade.service';
import { IApiService, IRequestOptions } from '../interfaces/api';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { makeUri } from '@utils/string.tool';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiFacadeService implements IApiService {
	constructor(private httpClient: HttpClient, private appConfig: ConfigFacadeService) {}

	private get apiUrl(): string {
		return this.appConfig.config.apiUrl;
	}

	public get<T>(uri: string, options: IRequestOptions = {}): Observable<T> {
		// @TODO: Remove after database explorer EPs are finished
		const apiUrl = uri.startsWith('database-explorer-') ? 'http://localhost:3000' : this.apiUrl;
		return this.httpClient.get<T>(makeUri(apiUrl, uri), options);
	}

	public post<T>(uri: string, body: any = {}, options: IRequestOptions = {}): Observable<T> {
		return this.httpClient.post<T>(makeUri(this.apiUrl, uri), body, options);
	}

	public put<T>(uri: string, body: any = {}, options: IRequestOptions = {}): Observable<T> {
		return this.httpClient.put<T>(makeUri(this.apiUrl, uri), body, options);
	}

	public delete<T>(uri: string, options: unknown = {}): Observable<T> {
		return this.httpClient.delete<T>(makeUri(this.apiUrl, uri), options);
	}

	// getFullResponse overrides the observe prop at our in-house IRequestOptions Interface
	// It return http response object with body, status code and headers
	public getFullResponse<T>(uri: string, options: IRequestOptions = {}): Observable<HttpResponse<T>> {
		return this.httpClient.get<T>(makeUri(this.apiUrl, uri), { ...options, observe: 'response' as const });
	}
}
